module.exports = __webpack_public_path__ + "static/media/ZSTO.39d62b33.pdf";